import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import { userExternalAccountsQueryKeys } from '@/modules/user-external-accounts/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

import { hiringManagerLinkedInEndpoints } from './constants';
import { hiringManagerLinkedInQueryKeys } from './queryKeys';

export const useDisconnectHiringManagerLinkedInMutation = () => {
  return useMutation({
    mutationFn: async (tenantId: string) => {
      await fetchClient.DELETE(hiringManagerLinkedInEndpoints.account, {
        params: { query: { tenantId } },
      });
    },
    onSettled: (_result, _error, tenantId) => {
      invalidateQuery(hiringManagerLinkedInQueryKeys.account(tenantId))();
      // The connection decides each job's outreach readiness and the portal's LinkedIn notices.
      invalidateQuery(userExternalAccountsQueryKeys.all)();
      invalidateQuery(jobsQueryKeys.all)();
    },
  });
};
